// extracted by mini-css-extract-plugin
export var cardHeader = "_rt-0";
export var reorderHandle = "_rt-3";
export var titleArea = "_rt-1";
export var titleAreaWithHandle = "_rt-2";